import { render } from "./RiwayatNonGtk.vue?vue&type=template&id=583090da"
import script from "./RiwayatNonGtk.vue?vue&type=script&lang=js"
export * from "./RiwayatNonGtk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__